import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MultiLanguageField } from '../model';
import { joinMultilangNames } from '../utils/multilang-names.util';

@Pipe({
  name: 'multilangNames',
  standalone: true,
})
export class MultilangNamesPipe implements PipeTransform {
  private readonly transloco = inject(TranslocoService);

  transform(
    names: MultiLanguageField | MultiLanguageField[] | null | undefined,
    separator = ', ',
  ): string {
    return joinMultilangNames(names, this.transloco.getActiveLang(), separator);
  }
}
